import { render, staticRenderFns } from "./StairSign.vue?vue&type=template&id=db84d2a6"
import script from "./StairSign.vue?vue&type=script&lang=js"
export * from "./StairSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports